import { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Avatar,
  FormControl,
  Select,
  MenuItem,
  Switch,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
//Icons
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
import { AuthContext } from "../Context/AuthContext";
import { SelectOffice } from "../Components/Include/DynamicSelect";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { GET_USER_WITH_PAGINATION, UPDATE_USER_IS_USE } from "../Schema/User";
import EmptyData from "../Components/Include/EmptyData";
import UserAction from "../Components/User/UserAction";
import UserForm from "../Components/User/UserForm";
import CreateIcon from "../Assets/create-icon.svg";

export default function User() {
  const [loading, setLoading] = useState(true);
  const { setAlert } = useContext(AuthContext);
  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));
  const [selectOffice, setSelectedOffice] = useState({ id: "", title: "" });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [role, setRole] = useState("All");

  const [status, setStatus] = useState("All");

  const { refetch } = useQuery(GET_USER_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      role: role,
      isUse: status === "All" ? null : status,
      officeId: selectOffice?.id ?? "",
    },
    onCompleted: ({ getUsersPagination }) => {
      // console.log(getUsersPagination?.data)
      setTableData(getUsersPagination?.data);
      setPaginationData(getUsersPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const [updateUserIsUse] = useMutation(UPDATE_USER_IS_USE, {
    onCompleted: ({ updateUserIsUse }) => {
      if (updateUserIsUse?.status) {
        setAlert(true, "success", updateUserIsUse?.message);
        refetch();
      } else {
        setAlert(true, "error", updateUserIsUse?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateUserIsUse({
      variables: {
        id: id,
        isUse: !status,
      },
    });
  };

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">អ្នកប្រើប្រាស់</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះអ្នកប្រើប្រាស់"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ជ្រើសរើសតួនាទី</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select value={role} onChange={(e) => setRole(e.target.value)}>
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value="SuperAdmin">SuperAdmin</MenuItem>
                <MenuItem value="StockController">StockController</MenuItem>
                <MenuItem value="Proposer">Proposer</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">ការិយាល័យ</Typography>
            <SelectOffice
              isUse={null}
              className="search-field"
              selectedVal={selectOffice}
              setSelectedVal={setSelectedOffice}
              setFieldValue={() => { }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value={true}>ប្រើប្រាស់</MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={8} lg={12} xl={2.4}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <UserForm
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
              dialogTitle="Create"
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell className="header-title-start" width="2%">
                  ល.រ
                </TableCell>
                <TableCell className="header-title" width="10%">
                  ឈ្មោះអ្នកប្រើប្រាស់
                </TableCell>
                <TableCell className="header-title" width="10%">
                  លេខទូរស័ព្ទ
                </TableCell>
                <TableCell className="header-title" width="9%">
                  អ៊ីម៉ែល
                </TableCell>
                <TableCell className="header-title" width="10%" align="center">
                  តួនាទី
                </TableCell>
                <TableCell className="header-title" width="10%" align="center">
                  Status
                </TableCell>
                <TableCell className="header-title-end" width="18%"></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={7} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={7} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>

                          <TableCell className="body-cell">
                            <Stack direction="row" spacing={1}>
                              <Avatar
                                sx={{ width: 40, height: 40 }}
                                alt={row?.mainUserId?.lastName}
                                src={row?.mainUserId?.imageSrc}
                              />
                              <Stack direction="column" justifyContent="center">
                                <Typography className="member-name">
                                  {row?.mainUserId?.lastName + " " + row?.mainUserId?.firstName}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.mainUserId?.tell}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.mainUserId?.email}
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            {row?.role}
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            <Box>
                              <Switch
                                disabled={
                                  userLogin?._id === row?._id ? true : false
                                }
                                checked={row?.isUse}
                                onChange={() =>
                                  handleUpdateStatus(row?._id, row?.isUse)
                                }
                              />
                            </Box>
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <UserAction
                              editData={row}
                              setRefetch={refetch}
                              userLogin={userLogin}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        // setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
